const calculateMetricValue = ({ value, locations }) => {
  if (value?.calculation === "length") {
    return locations?.length ?? null;
  } else if (value?.calculation === "sum") {
    return (
      locations
        ?.map((location) => location?.[value?.field])
        ?.filter((val) => val != null && !isNaN(val))
        ?.reduce((acc, curr) => acc + curr, 0) ?? null
    );
  } else {
    return value;
  }
};

export const calculateMetrics = ({ metrics, locations }) => {
  return (metrics ?? []).map((metric) => ({
    ...metric,
    value: calculateMetricValue({
      value: metric?.value,
      locations,
    }),
  }));
};
